module.exports = __webpack_public_path__ + "img/fundermax-obra-1-3.3e7d919a.jpg";